module.exports = __webpack_public_path__ + "static/media/noResults.3c8a431a.png";